export default "__VITE_ASSET__SYDZwW$L__"